import { Component, Input } from '@angular/core'

@Component({
  selector: 'vmf-trading-cutoff',
  templateUrl: './trading-cutoff.component.html',
  styleUrls: ['./trading-cutoff.component.scss'],
})
export class TradingCutoffComponent {
  @Input() performanceModel: any
}
